import React from 'react';
import { Star } from 'lucide-react';
export function BundleOffer() {
  return <section id="offer" className="bg-white py-12 px-4" data-id="element-47">
      <div className="max-w-3xl mx-auto bg-gray-50 rounded-2xl border-2 border-blue-100 shadow-xl overflow-hidden relative" data-id="element-48">
        <div className="bg-navy text-white py-3 px-4 flex items-center justify-center gap-3" data-id="element-49">
          <Star className="text-gold" size={20} fill="currentColor" data-id="element-50" />
          <h2 className="text-xl md:text-2xl font-bold m-0" data-id="element-51">
            Special American Values Offer
          </h2>
          <Star className="text-gold" size={20} fill="currentColor" data-id="element-52" />
        </div>

        <div className="absolute top-16 right-0 bg-patriot-red text-white text-xs font-bold px-8 py-1 transform rotate-45 translate-x-6 translate-y-4 shadow-md z-10" data-id="element-53">
          DIGITAL BUNDLE
        </div>

        <div className="p-6 md:p-8 text-center" data-id="element-54">
          <div className="bg-red-100 text-patriot-red-dark font-bold py-2 px-4 rounded-md inline-block mb-6 border border-red-200" data-id="element-55">
            URGENT: Only <span className="text-xl" data-id="element-56">123</span> copies left at
            this price!
          </div>

          <h3 className="text-2xl md:text-3xl font-bold text-navy mb-2" data-id="element-57">
            Unlock the Patriots Bundle
          </h3>
          <p className="text-lg text-gray-600 mb-1" data-id="element-58">
            eBook + Audiobook de regalo + 2 Bonuses
          </p>
          <p className="text-xl text-patriot-red font-bold mb-8" data-id="element-59">
            <span className="line-through text-gray-400 mr-2" data-id="element-60">
              $95.94 Value
            </span>{' '}
            Today just <span className="text-2xl" data-id="element-61">$29.97</span>
          </p>

          <div className="relative mb-8 max-w-lg mx-auto" data-id="element-62">
            <img src="https://cdn.magicpatterns.com/uploads/8VhdCTKEB5SoAzmACwizSF/Mockup_Audio_Book_Charlie_Kirk.png" alt="The Patriots Bundle Collection" className="w-full h-auto drop-shadow-2xl" data-id="element-63" />
          </div>

          <div className="text-gray-600 font-medium space-y-1" data-id="element-64">
            <p data-id="element-65">
              <strong data-id="element-66">Core:</strong> Voices of Freedom eBook + Audiobook –
              $47.97 Value
            </p>
            <p data-id="element-67">
              <strong data-id="element-68">Bonus #1:</strong> Remembering Charlie Kirk (eBook +
              Audiobook) – $23.98 Value
            </p>
            <p data-id="element-69">
              <strong data-id="element-70">Bonus #2:</strong> The Last Patriot (eBook + Audiobook) –
              $23.99 Value
            </p>
          </div>
        </div>
      </div>
    </section>;
}